module.exports = __webpack_public_path__ + "img/catstagram-details3.e5ef284e.png";